import Debug from 'debug';
import { inject, injectable } from 'inversify';
import { CancelToken } from '@/app/shared/command-queue'
import { waitToLoad, WaitToLoadError } from '@/app/shared/utils'
import { err } from '@xlearn/common'
import { QuestionStoreModuleSymbol, QuestionStoreModule, FindQuestionsError } from './question-store-module';

const debug = Debug('load-questions-job')

export type LoadQuestionsError = WaitToLoadError | FindQuestionsError

@injectable()
export class LoadQuestionsJob {

  constructor(
    @inject(QuestionStoreModuleSymbol)
    private questionStore: QuestionStoreModule) { }

  async execute(questionIds: string[], cancel: CancelToken) {

    debug('load questions')
    const result = await waitToLoad(() => this.questionStore.loadingPhase === 'loaded', cancel)
    if (!result.success) {
      return err(result.error as LoadQuestionsError)
    }

    const questions =  this.questionStore.findQuestions(questionIds)
    debug('questions loaded')

    return questions
  }
}
